<div class="description-container">
    <p data-cy="custom-page-description" class="description">
        {{ text }}
    </p>
</div>
